export default __webpack_public_path__ + "static/media/crude-on2.b871c9c7.svg";